var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClub = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "83px",
    viewBox: "0 1 68  62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#483B3B",
    fillRule: "evenodd",
    d: "M50.787 29.392c-1.828 0-3.588.289-5.238.818 3.433-3.081 5.59-7.533 5.59-12.483 0-9.302-7.613-16.842-17.004-16.842-9.39 0-17.003 7.54-17.003 16.842 0 4.95 2.156 9.402 5.589 12.483a17.134 17.134 0 00-5.238-.818C8.093 29.392.48 36.932.48 46.234c0 9.303 7.613 16.843 17.003 16.843 8.208 0 15.056-5.76 16.652-13.422 1.596 7.662 8.444 13.422 16.652 13.422 9.39 0 17.003-7.54 17.003-16.843 0-9.301-7.612-16.842-17.003-16.842"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClub, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/club.a4a0b60e.svg";
export { ForwardRef as ReactComponent };